import { IRootState } from '../../../store'
import { IDiagnosisOptionsState } from '../store/options.types'

export const getDiagnosisOptionsSelector = (state: IRootState): IDiagnosisOptionsState => state.options.diagnosisOptions
